import React from "react";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import ComponentErrorBoundary from "@danishagro/shared/src/components/molecules/ErrorBoundary/ComponentErrorBoundary.component";
import { SSH_Trustpilot } from "../../../../components/molecules/Trustpilot/Trustpilot.component";
import { V1Props } from "./EmbedV1.interface";
import S from "./EmbedV1.module.scss";

const V1 = ({ type }: V1Props) => {
    const getEmbeddedModule = () => {
        if (!type?.content) return null;
        switch (type.content.alias) {
            case "sleeknote": {
                // TypeScript now knows type.content.props has sleeknoteId
                const { sleeknoteId } = type.content.props;
                // Optional: error boundary
                if (!sleeknoteId) return null; // or throw new Error("Missing sleeknoteId");
                return (
                    <div className={S.wrapper}>
                        <DA_Container noVerticalPadding>
                            {/** Body */}
                            <div className={S.inner}>
                                <div id={sleeknoteId} />
                            </div>
                        </DA_Container>
                    </div>
                );
            }
            case "trustpilot": {
                const { dataTemplateId, dataBusinessUnitId, stars, theme } = type.content.props;
                return (
                    <DA_Container>
                        <SSH_Trustpilot
                            dataTemplateId={dataTemplateId}
                            dataBusinessUnitId={dataBusinessUnitId}
                            stars={stars}
                            theme={theme}
                        />
                    </DA_Container>
                );
            }
            default:
                return null;
        }
    };

    return (
        <ComponentErrorBoundary showNothing componentName="Embed Block">
            {getEmbeddedModule()}
        </ComponentErrorBoundary>
    );
};

export default V1;
